import translations from '../translations';
import { getDynamic } from '../services/translationService';

// Translation cache for offline support
const localCache = {};
const CACHE_KEY = 'qs_trans_cache';

// Load cache from localStorage
const loadCache = () => {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      const parsed = JSON.parse(cached);
      // Check if cache is still valid (7 days)
      if (Date.now() - parsed.timestamp < 7 * 24 * 60 * 60 * 1000) {
        return parsed.data;
      }
    }
  } catch {}
  return {};
};

// Save cache to localStorage
const saveCache = (data) => {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({
      timestamp: Date.now(),
      data
    }));
  } catch {}
};

// Initialize cache
const cachedData = loadCache();

export const t = (key, language = 'en') => {
  // 1. Check dynamic translations first (from Google Translate API)
  const dynamic = getDynamic(language);
  if (dynamic && dynamic[key]) return dynamic[key];
  
  // 2. Check static translations (en, zh, es)
  if (translations[language]) {
    const val = translations[language][key];
    if (val) return val;
  }
  
  // 3. Check local cache for dynamically translated languages
  if (localCache[language] && localCache[language][key]) {
    return localCache[language][key];
  }
  if (cachedData[language] && cachedData[language][key]) {
    return cachedData[language][key];
  }
  
  // 4. Fallback to English
  if (language !== 'en' && translations.en[key]) {
    return translations.en[key];
  }
  
  // 5. Last resort: return the key itself
  return key;
};

// Store translation in local cache
export const setTranslationCache = (language, key, value) => {
  if (!localCache[language]) localCache[language] = {};
  localCache[language][key] = value;
  
  // Also save to localStorage for persistence
  cachedData[language] = cachedData[language] || {};
  cachedData[language][key] = value;
  saveCache(cachedData);
};

export const getTranslation = (key, language = 'en') => t(key, language);

export const getLanguageName = (code) => {
  const languageNames = {
    en: 'English',
    zh: '中文',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    ja: '日本語',
    ko: '한국어',
    ru: 'Русский',
    pt: 'Português',
    it: 'Italiano',
    ar: 'العربية',
    hi: 'हिन्दी',
    no: 'Norsk',
  };
  return languageNames[code] || 'English';
};
